import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { setLoading } from '../redux/loaderAction';
import Loader from '../components/loader/Loader';
import SaveButton from '../components/buttons/SaveButton';
import CancelButton from '../components/buttons/CancelButton';
import Swal from '../messageBox/customSweetAlert';
import { currentDateFormat } from '../utils';
import { CREATE_BILL_RATE_CONFIGURATION, GET_SERVICE_NAMES, GET_ALL_PAYER } from '../constant';
import{billRateValidation} from "../validation/Validation";
import { GET_LOCATION_TYPE,GET_STATE_URI } from '../constant'; 

function BillRateConfiguration() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const loading = useSelector((state) => state.loader.loading);
    const [currentDate, setCurrentDate] = useState(new Date());
    
    const [formData, setFormData] = useState({
        service_id: '',
        procedure_code: '',
        base_code: '',
        milage_code: '',
        state: '',
        payer_id: '',
        status: '0',
        base_bill_rate: '',
        mileage_bill_rate: '0.00',
        effective_date: '',
        end_date: '',
        notes: ''
    });
    
    const [effectiveDate, setEffectiveDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    
    const [errors, setErrors] = useState({});
    
    // US States list for dropdown
    // const states = [
    //     'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut',
    //     'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa',
    //     'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan',
    //     'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire',
    //     'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma',
    //     'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee',
    //     'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
    // ];

    //const statusOptions = ['Active', 'Inactive'];
    const [states, setStateData] = useState([]);
    const [locationType, setLocationType] = useState([]);
    const [serviceNames, setServiceNames] = useState([]);
    const [serviceDetails, setServiceDetails] = useState(null);
    const [loadingServiceDetails, setLoadingServiceDetails] = useState(false);
    const [payerList, setPayerList] = useState([]);

    const loadUser = async ()=>{
        //dispatch(setLoading(true));
        const response1 = await axios.get(GET_STATE_URI);
        const response2 = await axios.get(GET_LOCATION_TYPE);
        const response3 = await axios.get(GET_SERVICE_NAMES,{
            params: { id: 2 }
        });
        const response4 = await axios.get(GET_ALL_PAYER);
        setStateData(response1.data);
        setLocationType(response2.data.data);
        setServiceNames(response3.data.data || []);
        setPayerList(response4.data || []);
    }

    const fetchServiceDetails = async (serviceId) => {
        try {
            if (!serviceId) {
                setServiceDetails(null);
                setLoadingServiceDetails(false);
                return;
            }
            
            setLoadingServiceDetails(true);
            
            // Find the selected service from the already loaded serviceNames
            const selectedService = serviceNames.find(service => service.id == serviceId);
            
            if (selectedService) {
                setServiceDetails(selectedService);
                // Auto-populate the form fields
                setFormData(prev => ({
                    ...prev,
                    procedure_code: selectedService.procedure_code || '',
                    base_code: selectedService.base_code || '',
                    milage_code: selectedService.milage_code || ''
                }));
            } else {
                setServiceDetails(null);
            }
        } catch (error) {
            console.error('Error fetching service details:', error);
            setServiceDetails(null);
        } finally {
            setLoadingServiceDetails(false);
        }
    };

    useEffect(() => {
        loadUser();
        setCurrentDate(new Date());
    }, []);

    // Fetch service details when service name changes
    useEffect(() => {
        if (formData.service_id) {
            fetchServiceDetails(formData.service_id);
        } else {
            setServiceDetails(null);
            // Clear the auto-populated fields when no service is selected
            setFormData(prev => ({
                ...prev,
                procedure_code: '',
                base_code: '',
                milage_code: ''
            }));
        }
    }, [formData.service_id]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
{}
   

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("formData1",formData);
        const isValid =  billRateValidation(formData);
       
        setErrors(isValid);
        if(Object.keys(isValid).length === 0){

        try {
            dispatch(setLoading(true));

            //return false;
            const response = await axios.post(CREATE_BILL_RATE_CONFIGURATION, formData);
            
            dispatch(setLoading(false));
            if (response.data.status === '200') {
                Swal.fire({
                    title: 'Success!',
                    text: response.data.message || 'Bill Rate Configuration has been saved successfully.',
                    icon: 'success',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                }).then(() => {
                    // Navigate back or reset form
                    navigate('/home/billing/bill-rate-list', { replace: true });
                });
            } else {
                Swal.fire({
                    title: 'Error!',
                    text: response.data.message || 'Failed to save bill rate configuration.',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
            }
            
        } catch (error) {
            dispatch(setLoading(false));
            console.error('Error saving bill rate configuration:', error);
            
            Swal.fire({
                title: 'Error!',
                text: 'Failed to save bill rate configuration. Please try again.',
                icon: 'error',
                confirmButtonText: 'OK',
                allowOutsideClick: false
            });
        }
    };  
}
    const handleClearForm = () => {
        setFormData({
            service_id: '',
            procedure_code: '',
            base_code: '',
            milage_code: '',
            state: '',
            payer_id: '',
            status: '0',
            base_bill_rate: '',
            mileage_bill_rate: '0.00',
            effective_date: '',
            end_date: '',
            notes: ''
        });
        setEffectiveDate(null);
        setEndDate(null);
        setServiceDetails(null);
        setErrors({});
    };

    const handleEffectiveDateChange = (date) => {
        setEffectiveDate(date);
        setFormData(prev => ({
            ...prev,
            effective_date: date ? `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}` : ''
        }));
    };

    const handleEndDateChange = (date) => {
        setEndDate(date);
        setFormData(prev => ({
            ...prev,
            end_date: date ? `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}` : ''
        }));
    };

    return (
        <>
            <div className="tab-pane fade active show" id="add-bill-rate" role="tabpanel" aria-labelledby="home-tab">
                <section>
                    <div className='d-flex justify-content-between form-container'>
                        <div>
                            <h2 className="fs-5 font-weight-600">Add New Bill Rate</h2>
                        </div>
                        <div>
                            <span>{currentDateFormat(currentDate)}</span>
                        </div>
                    </div>
                </section>
                
                <section>
                    <div className='bg-white px-5 py-4'>
                        <form onSubmit={handleSubmit}>
                            {/* Row 1 */}
                            <div className="row mb-4">
                                <div className="col-lg-4 col-md-6 mb-3">
                                    <label className='require-field'>Service Name</label>
                                    <select
                                        className={`form-select ${errors.service_name ? 'is-invalid' : ''}`}
                                        name="service_id"
                                        value={formData.service_id}
                                        onChange={handleInputChange}
                                        disabled={loadingServiceDetails}
                                    >
                                        <option value="">
                                            {loadingServiceDetails ? 'Loading services...' : 'Select Service Name'}
                                        </option>
                                        {serviceNames.map((service, index) => (
                                            <option key={index} value={service.id}>
                                                {service.service_name}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.service_id && <div className="errors">{errors.service_id}</div>}
                                </div>
                                
                               
                                
                                <div className="col-lg-2 col-md-4 mb-3">
                                    <label className='require-field'>Base Code</label>
                                    <div className="position-relative">
                                        <input
                                            type="text"
                                            className={`form-control ${errors.base_code ? 'is-invalid' : ''}`}
                                            name="base_code"
                                            value={formData.base_code}
                                            onChange={handleInputChange}
                                            placeholder={loadingServiceDetails ? 'Loading...' : 'Enter base code'}
                                            autoComplete='off'
                                            disabled={true}
                                            style={{ backgroundColor: '#f8f9fa' }}
                                        />
                                        {loadingServiceDetails && formData.service_name && (
                                            <div className="position-absolute top-50 end-0 translate-middle-y me-2">
                                                <div className="spinner-border spinner-border-sm" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    {errors.base_code && <div className="invalid-feedback">{errors.base_code}</div>}
                                </div>

                                <div className="col-lg-2 col-md-4 mb-3">
                                    <label className='require-field'>Mileage Code</label>
                                    <div className="position-relative">
                                        <input
                                            type="text"
                                            className={`form-control ${errors.milage_code ? 'is-invalid' : ''}`}
                                            name="milage_code"
                                            value={formData.milage_code}
                                            onChange={handleInputChange}
                                            placeholder={loadingServiceDetails ? 'Loading...' : 'Enter mileage code'}
                                            autoComplete='off'
                                            disabled={true}
                                            style={{ backgroundColor: '#f8f9fa' }}
                                        />
                                        {loadingServiceDetails && formData.service_name && (
                                            <div className="position-absolute top-50 end-0 translate-middle-y me-2">
                                                <div className="spinner-border spinner-border-sm" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    {errors.milage_code && <div className="invalid-feedback">{errors.milage_code}</div>}
                                </div>
                            </div>

                            {/* Row 2 */}
                            <div className="row mb-4">
                                <div className="col-lg-4 col-md-6 mb-3">
                                    <label className='require-field'>State</label>
                                    <select
                                        className={`form-select ${errors.state ? 'is-invalid' : ''}`}
                                        name="state"
                                        value={formData.state}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Select State</option>
                                        {states.map((state, index) => (
                                            <option key={index} value={state.state_id || state.id}>
                                                {state.state_name || state.name}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.state && <div className="invalid-feedback">{errors.state}</div>}
                                </div>
                                
                                <div className="col-lg-4 col-md-6 mb-3">
                                    <label className='require-field'>Payer Name</label>
                                    <select
                                        className={`form-select ${errors.payer_id ? 'is-invalid' : ''}`}
                                        name="payer_id"
                                        value={formData.payer_id}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Select Payer</option>
                                        {payerList.map((payer, index) => (
                                            <option key={index} value={payer.id}>
                                                {payer.payer_name}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.payer_id && <div className="invalid-feedback">{errors.payer_id}</div>}
                                </div>
                                
                                <div className="col-lg-4 col-md-6 mb-3">
                                    <label>Status</label>
                                    <select
                                        className="form-select"
                                        name="status"
                                        value={formData.status}
                                        onChange={handleInputChange}
                                    >
                                         <option  value="0">Active</option>
                                         <option  value="1">Inactive</option>
                                    </select>
                                </div>
                            </div>

                            {/* Row 3 */}
                            <div className="row mb-4">
                                <div className="col-lg-4 col-md-6 mb-3">
                                    <label className='require-field'>Base Bill Rate</label>
                                    <input
                                        type="number"
                                        step="0.01"
                                        className={`form-control ${errors.base_bill_rate ? 'is-invalid' : ''}`}
                                        name="base_bill_rate"
                                        value={formData.base_bill_rate}
                                        onChange={handleInputChange}
                                        placeholder="Enter base bill rate"
                                        autoComplete='off'
                                    />
                                    {errors.base_bill_rate && <div className="invalid-feedback">{errors.base_bill_rate}</div>}
                                </div>
                                
                                <div className="col-lg-4 col-md-6 mb-3">
                                    <label className='require-field'>Mileage Bill Rate</label>
                                    <input
                                        type="number"
                                        step="0.01"
                                        className={`form-control ${errors.mileage_bill_rate ? 'is-invalid' : ''}`}
                                        name="mileage_bill_rate"
                                        value={formData.mileage_bill_rate}
                                        onChange={handleInputChange}
                                        placeholder="Enter mileage bill rate"
                                        autoComplete='off'
                                    />
                                    {errors.mileage_bill_rate && <div className="invalid-feedback">{errors.mileage_bill_rate}</div>}
                                </div>
                            </div>

                            {/* Row 4 */}
                            <div className="row mb-4">
                                <div className="col-lg-4 col-md-6 mb-3">
                                    <div>
                                        <label className='require-field d-block'>Effective Date</label>
                                        <DatePicker
                                            selected={effectiveDate}
                                            onChange={handleEffectiveDateChange}
                                            dateFormat="MM/dd/yyyy"
                                            className="form-control"
                                            placeholderText="Select effective date"
                                            isClearable
                                            minDate={new Date()}
                                        />
                                    </div>
                                </div>
                                
                                <div className="col-lg-4 col-md-6 mb-3">
                                    <div>
                                        <label className='require-field d-block'>End Date</label>
                                        <DatePicker
                                            selected={endDate}
                                            onChange={handleEndDateChange}
                                            dateFormat="MM/dd/yyyy"
                                            className="form-control"
                                            placeholderText="Select end date"
                                            isClearable
                                            minDate={effectiveDate || new Date()}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Notes Section */}
                            <div className="row mb-4">
                                <div className="col-12">
                                    <label className='require-field'>Notes</label>
                                    <textarea
                                        className="form-control"
                                        name="notes"
                                        value={formData.notes}
                                        onChange={handleInputChange}
                                        placeholder="Additional notes or comments"
                                        rows="4"
                                        style={{ resize: 'both' }}
                                    />
                                </div>
                            </div>

                            {/* Action Buttons */}
                            <div className='footer-content'>
                                <SaveButton 
                                    type='submit' 
                                    buttonTitle={'Add Rate'} 
                                />
                                <button
                                    type="button"
                                    className="btn btn-secondary me-2"
                                    onClick={handleClearForm}
                                >
                                    Clear Form
                                </button>
                                <CancelButton 
                                    cancelHandler={() => navigate('/home/billing/list', { replace: true })} 
                                />
                            </div>
                        </form>
                    </div>
                </section>
            </div>
            
            <div>
                {loading && <Loader />}
            </div>
        </>
    );
}

export default BillRateConfiguration;
